/**
 * Send & Settle Tab
 */

const state = {
  preferred_repayment_amount: '',
  finance_commission: '',
  origination_fee: '',
  lender_contract_number: '',
  lender_application_id: '',

  remittance_date: ''
}

const getters = {
  getState(state) {
    return state
  }
}

// Mutations must be synchronous...
const mutations = {
  saveApiData(state, payload) {
    const { data } = payload
    Object.keys(state).forEach((key) => {
      if (data[key]) state[key] = data[key]
    })
  }
}

// Actions can be asynchronous...
const actions = {
  loadApiData(context, payload) {
    Ambition.Request.call({
      url: `/api/application/{application}/send-and-settle`,
      method: 'GET'
    }).then((response) => {
      // console.warn('SUCCESS: loadApiData()', response)
      context.commit('saveApiData', response)
    }).catch((error) => {
      console.error('ERROR: loadApiData()', error)
    })
  },

  saveCreditProposalData(context, payload) {
    const { preferred_repayment_amount, finance_commission } = context.state

    return Ambition.Request.call({
      url: `/api/application/{application}/send-and-settle/credit-proposal`,
      method: 'POST',
      data: {
        preferred_repayment_amount,
        finance_commission,
      }
    }).then((response) => {
    //   console.warn('SUCCESS: saveCreditProposalData()', response)
    }).catch((error) => {
    //   console.warn('ERROR: saveCreditProposalData()', error)
    })
  },

  saveBrokerInvoiceData(context, payload) {
    const { finance_commission, origination_fee, lender_contract_number, lender_application_id } = context.state

    return Ambition.Request.call({
      url: `/api/application/{application}/send-and-settle/broker-invoice`,
      method: 'POST',
      data: {
        finance_commission,
        origination_fee,
        lender_contract_number,
        lender_application_id,
      }
    }).then((response) => {
    //   console.warn('SUCCESS: saveBrokerInvoiceData()', response)
    }).catch((error) => {
    //   console.warn('ERROR: saveBrokerInvoiceData()', error)
    })
  },

  // saveSettlementAdvice(context, payload) {
  //   const { lender_contract_number, remittance_date } = context.state

  //   return Ambition.Request.call({
  //     url: `/api/application/{application}/send-and-settle/settlement-advice`,
  //     method: 'POST',
  //     data: {
  //       lender_contract_number,
  //       remittance_date
  //     }
  //   }).then((response) => {
  //     console.warn('SUCCESS: saveSettlementAdvice()', response)
  //   }).catch((error) => {
  //     console.warn('ERROR: saveSettlementAdvice()', error)
  //   })
  // }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
